import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Container } from 'amphitheatre';

const Wrapper = styled.div`
  color: white;
  font-family: 'Lato';
  padding: 0.5rem;
`;

const Footer: React.FunctionComponent = () => {
  return (
    <Wrapper className="footer">
      <Container size="lg">
        Copyright © 2020 |
        <Link to="/rules">
          Saber Astronautics' Quest For Blue Competition Rules and Regulations
        </Link>
      </Container>
    </Wrapper>
  );
};

export default Footer;
